import { inject } from '@angular/core';

import { BaasAppState } from '@lvflanders/bar';
import { BAR_LOCALHOST } from '@lvflanders/bar-ng';
import { BarAppMenuItem } from '@lvflanders/bar-ng-ui';

export function defineAppMenu(): BarAppMenuItem[] {
    const state = inject(BaasAppState);
    const localhost = inject<boolean>(BAR_LOCALHOST);

    function checkOtherItemWithWithPathMatch(appCode: string): boolean {
        return state.config.baasStatic.appMenuItems.some((ami) => {
            return ami.appCode === appCode && ami.pathMatches && ami.pathMatches.length && checkPathMath(ami.pathMatches);
        });
    }

    function checkPathMath(pathMatches: string[]): boolean {
        if (window.location.href.toLowerCase().startsWith(state.location.appRoot.url.toLowerCase())) {
            const currentPath = window.location.href.substring(state.location.appRoot.url.length - 1);
            if (pathMatches.some((pm) => currentPath.toLowerCase().startsWith(pm.toLowerCase()))) return true;
        }
        return false;
    }

    if (state.config.baasStatic?.appMenuItems) {
        // define app menu based on configuration from BaaS static
        return state.config.baasStatic.appMenuItems
            .filter((ami) => {
                // zone filter
                let result = !ami.zone || ami.zone === state.basiscontext.zone;
                // hoedanigheid check
                if (
                    result &&
                    state.basiscontext?.hoedanigheidRolcode &&
                    ami.excludedHoedanigheidRolcodes &&
                    // check if hoedanigheid is excluded if present
                    ami.excludedHoedanigheidRolcodes.indexOf(state.basiscontext.hoedanigheidRolcode) > -1
                ) {
                    // hoedanigheid not allowed
                    result = false;
                }
                // beheersdienst check
                if (result && ami.beheersdienst != null) {
                    let beheersdienst = false;
                    if (state.basiscontext?.hoedanigheid && state.basiscontext?.hoedanigheidRolcode) {
                        // check whether current hoedanigheid is a beheersdienst
                        beheersdienst = state.userInfo.hoedanigheidInfoSet?.some(
                            (hi) => hi.isBeheersdienst && hi.rolcode === state.basiscontext.hoedanigheidRolcode && hi.value === state.basiscontext.hoedanigheid
                        );
                    }
                    if ((ami.beheersdienst === true && !beheersdienst) || (ami.beheersdienst === false && beheersdienst)) result = false;
                }

                return result;
            })
            .map((ami) => {
                let selected = false;
                if (ami.appCode === state.toepassing.code) {
                    if (!ami.pathMatches || ami.pathMatches.length == 0) {
                        if (!checkOtherItemWithWithPathMatch(ami.appCode)) selected = true;
                    } else if (checkPathMath(ami.pathMatches)) {
                        selected = true;
                    }
                }
                const appMenuItem: BarAppMenuItem = {
                    content: ami.title,
                    // NOTE iconen zijn disabled
                    // icon: {
                    //     srText: ami.title,
                    //     position: 'top',
                    //     class: ami.iconClass
                    // },
                    selected: selected,
                    mobile: ami.mobile,
                    hidden: ami.hidden,
                    disabled: ami.disabled,
                    target: '_self'
                };

                const url = localhost && ami.appCode === state.toepassing.code ? ami.urlLocalhost || ami.url : ami.url;
                if (ami.appCode === state.toepassing.code) {
                    // in case we are in the current page extract the route and use routerUrl (no need for full page refresh)
                    appMenuItem.routerUrl = url.replace(state.location.app.url, '');
                    if (appMenuItem.routerUrl === '') appMenuItem.routerUrl = '/';
                } else {
                    // external application use a href
                    appMenuItem.href = url;
                }

                return appMenuItem;
            });
    } else return [];
}
